import "./main.css";
import {classNames as $joUWQ$classNames, useDOMRef as $joUWQ$useDOMRef, useStyleProps as $joUWQ$useStyleProps} from "@react-spectrum/utils";
import $joUWQ$react from "react";
import {useProgressBar as $joUWQ$useProgressBar} from "@react-aria/progress";
import {clamp as $joUWQ$clamp} from "@react-aria/utils";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


var $a43f840f49ffbe32$exports = {};

$parcel$export($a43f840f49ffbe32$exports, "focus-ring", () => $a43f840f49ffbe32$export$f39a09f249340e2a, (v) => $a43f840f49ffbe32$export$f39a09f249340e2a = v);
$parcel$export($a43f840f49ffbe32$exports, "i18nFontFamily", () => $a43f840f49ffbe32$export$8c4ee2c50c22c514, (v) => $a43f840f49ffbe32$export$8c4ee2c50c22c514 = v);
$parcel$export($a43f840f49ffbe32$exports, "indeterminate-loop-ltr", () => $a43f840f49ffbe32$export$a889038a25113dd4, (v) => $a43f840f49ffbe32$export$a889038a25113dd4 = v);
$parcel$export($a43f840f49ffbe32$exports, "indeterminate-loop-rtl", () => $a43f840f49ffbe32$export$aeff243cf3356f00, (v) => $a43f840f49ffbe32$export$aeff243cf3356f00 = v);
$parcel$export($a43f840f49ffbe32$exports, "is-critical", () => $a43f840f49ffbe32$export$a1f608a9810da50f, (v) => $a43f840f49ffbe32$export$a1f608a9810da50f = v);
$parcel$export($a43f840f49ffbe32$exports, "is-positive", () => $a43f840f49ffbe32$export$aea9fd919467f03a, (v) => $a43f840f49ffbe32$export$aea9fd919467f03a = v);
$parcel$export($a43f840f49ffbe32$exports, "is-warning", () => $a43f840f49ffbe32$export$d4ebda6218901908, (v) => $a43f840f49ffbe32$export$d4ebda6218901908 = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-BarLoader", () => $a43f840f49ffbe32$export$162ba336fb0c239f, (v) => $a43f840f49ffbe32$export$162ba336fb0c239f = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-BarLoader--indeterminate", () => $a43f840f49ffbe32$export$1249dfbb98223794, (v) => $a43f840f49ffbe32$export$1249dfbb98223794 = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-BarLoader--overBackground", () => $a43f840f49ffbe32$export$55612d0bd9b5d41, (v) => $a43f840f49ffbe32$export$55612d0bd9b5d41 = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-BarLoader--sideLabel", () => $a43f840f49ffbe32$export$99af8802cc2a10dc, (v) => $a43f840f49ffbe32$export$99af8802cc2a10dc = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-BarLoader--small", () => $a43f840f49ffbe32$export$b945305960ad74a7, (v) => $a43f840f49ffbe32$export$b945305960ad74a7 = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-BarLoader--staticBlack", () => $a43f840f49ffbe32$export$f45257a01e7aabeb, (v) => $a43f840f49ffbe32$export$f45257a01e7aabeb = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-BarLoader--staticWhite", () => $a43f840f49ffbe32$export$734e9273ae1f542e, (v) => $a43f840f49ffbe32$export$734e9273ae1f542e = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-BarLoader-fill", () => $a43f840f49ffbe32$export$84c9ee7bc724b71b, (v) => $a43f840f49ffbe32$export$84c9ee7bc724b71b = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-BarLoader-label", () => $a43f840f49ffbe32$export$5379ba198163be86, (v) => $a43f840f49ffbe32$export$5379ba198163be86 = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-BarLoader-percentage", () => $a43f840f49ffbe32$export$ecc9c825de9d1a18, (v) => $a43f840f49ffbe32$export$ecc9c825de9d1a18 = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-BarLoader-track", () => $a43f840f49ffbe32$export$3e2e13fb57b5c74b, (v) => $a43f840f49ffbe32$export$3e2e13fb57b5c74b = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-FocusRing-ring", () => $a43f840f49ffbe32$export$4109102f950813a6, (v) => $a43f840f49ffbe32$export$4109102f950813a6 = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-FocusRing", () => $a43f840f49ffbe32$export$24c7f46a6e3605dd, (v) => $a43f840f49ffbe32$export$24c7f46a6e3605dd = v);
$parcel$export($a43f840f49ffbe32$exports, "spectrum-FocusRing--quiet", () => $a43f840f49ffbe32$export$2927016961429360, (v) => $a43f840f49ffbe32$export$2927016961429360 = v);
var $a43f840f49ffbe32$export$f39a09f249340e2a;
var $a43f840f49ffbe32$export$8c4ee2c50c22c514;
var $a43f840f49ffbe32$export$a889038a25113dd4;
var $a43f840f49ffbe32$export$aeff243cf3356f00;
var $a43f840f49ffbe32$export$a1f608a9810da50f;
var $a43f840f49ffbe32$export$aea9fd919467f03a;
var $a43f840f49ffbe32$export$d4ebda6218901908;
var $a43f840f49ffbe32$export$162ba336fb0c239f;
var $a43f840f49ffbe32$export$1249dfbb98223794;
var $a43f840f49ffbe32$export$55612d0bd9b5d41;
var $a43f840f49ffbe32$export$99af8802cc2a10dc;
var $a43f840f49ffbe32$export$b945305960ad74a7;
var $a43f840f49ffbe32$export$f45257a01e7aabeb;
var $a43f840f49ffbe32$export$734e9273ae1f542e;
var $a43f840f49ffbe32$export$84c9ee7bc724b71b;
var $a43f840f49ffbe32$export$5379ba198163be86;
var $a43f840f49ffbe32$export$ecc9c825de9d1a18;
var $a43f840f49ffbe32$export$3e2e13fb57b5c74b;
var $a43f840f49ffbe32$export$4109102f950813a6;
var $a43f840f49ffbe32$export$24c7f46a6e3605dd;
var $a43f840f49ffbe32$export$2927016961429360;
$a43f840f49ffbe32$export$f39a09f249340e2a = `uFrYBa_focus-ring`;
$a43f840f49ffbe32$export$8c4ee2c50c22c514 = `uFrYBa_i18nFontFamily`;
$a43f840f49ffbe32$export$a889038a25113dd4 = `uFrYBa_indeterminate-loop-ltr`;
$a43f840f49ffbe32$export$a889038a25113dd4;
$a43f840f49ffbe32$export$aeff243cf3356f00 = `uFrYBa_indeterminate-loop-rtl`;
$a43f840f49ffbe32$export$aeff243cf3356f00;
$a43f840f49ffbe32$export$a1f608a9810da50f = `uFrYBa_is-critical`;
$a43f840f49ffbe32$export$aea9fd919467f03a = `uFrYBa_is-positive`;
$a43f840f49ffbe32$export$d4ebda6218901908 = `uFrYBa_is-warning`;
$a43f840f49ffbe32$export$162ba336fb0c239f = `uFrYBa_spectrum-BarLoader`;
$a43f840f49ffbe32$export$1249dfbb98223794 = `uFrYBa_spectrum-BarLoader--indeterminate`;
$a43f840f49ffbe32$export$55612d0bd9b5d41 = `uFrYBa_spectrum-BarLoader--overBackground`;
$a43f840f49ffbe32$export$99af8802cc2a10dc = `uFrYBa_spectrum-BarLoader--sideLabel`;
$a43f840f49ffbe32$export$b945305960ad74a7 = `uFrYBa_spectrum-BarLoader--small`;
$a43f840f49ffbe32$export$f45257a01e7aabeb = `uFrYBa_spectrum-BarLoader--staticBlack`;
$a43f840f49ffbe32$export$734e9273ae1f542e = `uFrYBa_spectrum-BarLoader--staticWhite`;
$a43f840f49ffbe32$export$84c9ee7bc724b71b = `uFrYBa_spectrum-BarLoader-fill`;
$a43f840f49ffbe32$export$5379ba198163be86 = `uFrYBa_spectrum-BarLoader-label`;
$a43f840f49ffbe32$export$ecc9c825de9d1a18 = `uFrYBa_spectrum-BarLoader-percentage`;
$a43f840f49ffbe32$export$3e2e13fb57b5c74b = `uFrYBa_spectrum-BarLoader-track`;
$a43f840f49ffbe32$export$4109102f950813a6 = `uFrYBa_spectrum-FocusRing-ring`;
$a43f840f49ffbe32$export$24c7f46a6e3605dd = `uFrYBa_spectrum-FocusRing ${$a43f840f49ffbe32$export$4109102f950813a6}`;
$a43f840f49ffbe32$export$2927016961429360 = `uFrYBa_spectrum-FocusRing--quiet`;


// Base ProgressBar component shared with Meter.
function $ddf9337e928b5fe6$var$ProgressBarBase(props, ref) {
    let { value: value = 0, minValue: minValue = 0, maxValue: maxValue = 100, size: size = "L", label: label, barClassName: barClassName, showValueLabel: showValueLabel = !!label, labelPosition: labelPosition = "top", isIndeterminate: isIndeterminate = false, barProps: barProps, labelProps: labelProps, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, ...otherProps } = props;
    let domRef = (0, $joUWQ$useDOMRef)(ref);
    let { styleProps: styleProps } = (0, $joUWQ$useStyleProps)(otherProps);
    value = (0, $joUWQ$clamp)(value, minValue, maxValue);
    let barStyle = {};
    if (!isIndeterminate) {
        let percentage = (value - minValue) / (maxValue - minValue);
        barStyle.width = `${Math.round(percentage * 100)}%`;
    }
    // Ideally this should be in useProgressBar, but children
    // are not supported in ProgressCircle which shares that hook...
    if (!label && !ariaLabel && !ariaLabelledby) console.warn("If you do not provide a visible label via children, you must specify an aria-label or aria-labelledby attribute for accessibility");
    // use inline style for fit-content because cssnano is too smart for us and will strip out the -moz prefix in css files
    return /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        ...barProps,
        ref: domRef,
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($a43f840f49ffbe32$exports))), "spectrum-BarLoader", {
            "spectrum-BarLoader--small": size === "S",
            "spectrum-BarLoader--large": size === "L",
            "spectrum-BarLoader--indeterminate": isIndeterminate,
            "spectrum-BarLoader--sideLabel": labelPosition === "side"
        }, barClassName, styleProps.className),
        style: {
            minWidth: "-moz-fit-content",
            ...styleProps.style
        }
    }, label && /*#__PURE__*/ (0, $joUWQ$react).createElement("span", {
        ...labelProps,
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($a43f840f49ffbe32$exports))), "spectrum-BarLoader-label")
    }, label), showValueLabel && barProps && /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($a43f840f49ffbe32$exports))), "spectrum-BarLoader-percentage")
    }, barProps["aria-valuetext"]), /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($a43f840f49ffbe32$exports))), "spectrum-BarLoader-track")
    }, /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($a43f840f49ffbe32$exports))), "spectrum-BarLoader-fill"),
        style: barStyle
    })));
}
let $ddf9337e928b5fe6$export$7c6ed87244065f3a = /*#__PURE__*/ (0, $joUWQ$react).forwardRef($ddf9337e928b5fe6$var$ProgressBarBase);





function $551ca31cb687f352$var$ProgressBar(props, ref) {
    let { staticColor: staticColor, variant: variant, ...otherProps } = props;
    const { progressBarProps: progressBarProps, labelProps: labelProps } = (0, $joUWQ$useProgressBar)(props);
    return /*#__PURE__*/ (0, $joUWQ$react).createElement((0, $ddf9337e928b5fe6$export$7c6ed87244065f3a), {
        ...otherProps,
        ref: ref,
        barProps: progressBarProps,
        labelProps: labelProps,
        barClassName: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($a43f840f49ffbe32$exports))), {
            "spectrum-BarLoader--overBackground": variant === "overBackground",
            "spectrum-BarLoader--staticWhite": staticColor === "white",
            "spectrum-BarLoader--staticBlack": staticColor === "black"
        })
    });
}
/**
 * ProgressBars show the progression of a system operation: downloading, uploading, processing, etc., in a visual way.
 * They can represent either determinate or indeterminate progress.
 */ let $551ca31cb687f352$export$c17561cb55d4db30 = /*#__PURE__*/ (0, $joUWQ$react).forwardRef($551ca31cb687f352$var$ProgressBar);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


var $91c958cb2e66ca21$exports = {};

$parcel$export($91c958cb2e66ca21$exports, "focus-ring", () => $91c958cb2e66ca21$export$f39a09f249340e2a, (v) => $91c958cb2e66ca21$export$f39a09f249340e2a = v);
$parcel$export($91c958cb2e66ca21$exports, "i18nFontFamily", () => $91c958cb2e66ca21$export$8c4ee2c50c22c514, (v) => $91c958cb2e66ca21$export$8c4ee2c50c22c514 = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader", () => $91c958cb2e66ca21$export$9633d311d6d6830b, (v) => $91c958cb2e66ca21$export$9633d311d6d6830b = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader--indeterminate", () => $91c958cb2e66ca21$export$79b7e5abeef5134f, (v) => $91c958cb2e66ca21$export$79b7e5abeef5134f = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader--indeterminate-fill-submask-2", () => $91c958cb2e66ca21$export$f7083dbeadcbb2bd, (v) => $91c958cb2e66ca21$export$f7083dbeadcbb2bd = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader--large", () => $91c958cb2e66ca21$export$c8c34e5e37bf511c, (v) => $91c958cb2e66ca21$export$c8c34e5e37bf511c = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader--overBackground", () => $91c958cb2e66ca21$export$6668708cb539f403, (v) => $91c958cb2e66ca21$export$6668708cb539f403 = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader--small", () => $91c958cb2e66ca21$export$79819ab9844dbe9b, (v) => $91c958cb2e66ca21$export$79819ab9844dbe9b = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader--staticBlack", () => $91c958cb2e66ca21$export$7f8072f8867b580e, (v) => $91c958cb2e66ca21$export$7f8072f8867b580e = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader--staticWhite", () => $91c958cb2e66ca21$export$f2e90b77c21d4ec7, (v) => $91c958cb2e66ca21$export$f2e90b77c21d4ec7 = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader-fill", () => $91c958cb2e66ca21$export$58fb9ac68cf8e784, (v) => $91c958cb2e66ca21$export$58fb9ac68cf8e784 = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader-fillMask1", () => $91c958cb2e66ca21$export$b676cd958401a736, (v) => $91c958cb2e66ca21$export$b676cd958401a736 = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader-fillMask2", () => $91c958cb2e66ca21$export$8c428f4f13e424b, (v) => $91c958cb2e66ca21$export$8c428f4f13e424b = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader-fillSubMask1", () => $91c958cb2e66ca21$export$98ba5ef650aeb8ca, (v) => $91c958cb2e66ca21$export$98ba5ef650aeb8ca = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader-fillSubMask2", () => $91c958cb2e66ca21$export$dc70b48c897b0f1a, (v) => $91c958cb2e66ca21$export$dc70b48c897b0f1a = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader-fills", () => $91c958cb2e66ca21$export$3038f4c0c86f539b, (v) => $91c958cb2e66ca21$export$3038f4c0c86f539b = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-CircleLoader-track", () => $91c958cb2e66ca21$export$278efdb85ed802da, (v) => $91c958cb2e66ca21$export$278efdb85ed802da = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-FocusRing-ring", () => $91c958cb2e66ca21$export$4109102f950813a6, (v) => $91c958cb2e66ca21$export$4109102f950813a6 = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-FocusRing", () => $91c958cb2e66ca21$export$24c7f46a6e3605dd, (v) => $91c958cb2e66ca21$export$24c7f46a6e3605dd = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-FocusRing--quiet", () => $91c958cb2e66ca21$export$2927016961429360, (v) => $91c958cb2e66ca21$export$2927016961429360 = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-fill-mask-1", () => $91c958cb2e66ca21$export$524c81e63e1d64f5, (v) => $91c958cb2e66ca21$export$524c81e63e1d64f5 = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-fill-mask-2", () => $91c958cb2e66ca21$export$7219832bea80eb54, (v) => $91c958cb2e66ca21$export$7219832bea80eb54 = v);
$parcel$export($91c958cb2e66ca21$exports, "spectrum-fills-rotate", () => $91c958cb2e66ca21$export$3663cbdb240663ec, (v) => $91c958cb2e66ca21$export$3663cbdb240663ec = v);
var $91c958cb2e66ca21$export$f39a09f249340e2a;
var $91c958cb2e66ca21$export$8c4ee2c50c22c514;
var $91c958cb2e66ca21$export$9633d311d6d6830b;
var $91c958cb2e66ca21$export$79b7e5abeef5134f;
var $91c958cb2e66ca21$export$f7083dbeadcbb2bd;
var $91c958cb2e66ca21$export$c8c34e5e37bf511c;
var $91c958cb2e66ca21$export$6668708cb539f403;
var $91c958cb2e66ca21$export$79819ab9844dbe9b;
var $91c958cb2e66ca21$export$7f8072f8867b580e;
var $91c958cb2e66ca21$export$f2e90b77c21d4ec7;
var $91c958cb2e66ca21$export$58fb9ac68cf8e784;
var $91c958cb2e66ca21$export$b676cd958401a736;
var $91c958cb2e66ca21$export$8c428f4f13e424b;
var $91c958cb2e66ca21$export$98ba5ef650aeb8ca;
var $91c958cb2e66ca21$export$dc70b48c897b0f1a;
var $91c958cb2e66ca21$export$3038f4c0c86f539b;
var $91c958cb2e66ca21$export$278efdb85ed802da;
var $91c958cb2e66ca21$export$4109102f950813a6;
var $91c958cb2e66ca21$export$24c7f46a6e3605dd;
var $91c958cb2e66ca21$export$2927016961429360;
var $91c958cb2e66ca21$export$524c81e63e1d64f5;
var $91c958cb2e66ca21$export$7219832bea80eb54;
var $91c958cb2e66ca21$export$3663cbdb240663ec;
$91c958cb2e66ca21$export$f39a09f249340e2a = `EQYv7q_focus-ring`;
$91c958cb2e66ca21$export$8c4ee2c50c22c514 = `EQYv7q_i18nFontFamily`;
$91c958cb2e66ca21$export$9633d311d6d6830b = `EQYv7q_spectrum-CircleLoader`;
$91c958cb2e66ca21$export$79b7e5abeef5134f = `EQYv7q_spectrum-CircleLoader--indeterminate`;
$91c958cb2e66ca21$export$f7083dbeadcbb2bd = `EQYv7q_spectrum-CircleLoader--indeterminate-fill-submask-2`;
$91c958cb2e66ca21$export$c8c34e5e37bf511c = `EQYv7q_spectrum-CircleLoader--large`;
$91c958cb2e66ca21$export$6668708cb539f403 = `EQYv7q_spectrum-CircleLoader--overBackground`;
$91c958cb2e66ca21$export$79819ab9844dbe9b = `EQYv7q_spectrum-CircleLoader--small`;
$91c958cb2e66ca21$export$7f8072f8867b580e = `EQYv7q_spectrum-CircleLoader--staticBlack`;
$91c958cb2e66ca21$export$f2e90b77c21d4ec7 = `EQYv7q_spectrum-CircleLoader--staticWhite`;
$91c958cb2e66ca21$export$58fb9ac68cf8e784 = `EQYv7q_spectrum-CircleLoader-fill`;
$91c958cb2e66ca21$export$b676cd958401a736 = `EQYv7q_spectrum-CircleLoader-fillMask1`;
$91c958cb2e66ca21$export$8c428f4f13e424b = `EQYv7q_spectrum-CircleLoader-fillMask2`;
$91c958cb2e66ca21$export$98ba5ef650aeb8ca = `EQYv7q_spectrum-CircleLoader-fillSubMask1`;
$91c958cb2e66ca21$export$dc70b48c897b0f1a = `EQYv7q_spectrum-CircleLoader-fillSubMask2`;
$91c958cb2e66ca21$export$3038f4c0c86f539b = `EQYv7q_spectrum-CircleLoader-fills`;
$91c958cb2e66ca21$export$278efdb85ed802da = `EQYv7q_spectrum-CircleLoader-track`;
$91c958cb2e66ca21$export$4109102f950813a6 = `EQYv7q_spectrum-FocusRing-ring`;
$91c958cb2e66ca21$export$24c7f46a6e3605dd = `EQYv7q_spectrum-FocusRing ${$91c958cb2e66ca21$export$4109102f950813a6}`;
$91c958cb2e66ca21$export$2927016961429360 = `EQYv7q_spectrum-FocusRing--quiet`;
$91c958cb2e66ca21$export$524c81e63e1d64f5 = `EQYv7q_spectrum-fill-mask-1`;
$91c958cb2e66ca21$export$524c81e63e1d64f5;
$91c958cb2e66ca21$export$7219832bea80eb54 = `EQYv7q_spectrum-fill-mask-2`;
$91c958cb2e66ca21$export$7219832bea80eb54;
$91c958cb2e66ca21$export$3663cbdb240663ec = `EQYv7q_spectrum-fills-rotate`;
$91c958cb2e66ca21$export$3663cbdb240663ec;



function $79c16f64960b6385$var$ProgressCircle(props, ref) {
    let { value: value = 0, minValue: minValue = 0, maxValue: maxValue = 100, size: size = "M", staticColor: staticColor, variant: variant, isIndeterminate: isIndeterminate = false, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, ...otherProps } = props;
    let domRef = (0, $joUWQ$useDOMRef)(ref);
    let { styleProps: styleProps } = (0, $joUWQ$useStyleProps)(otherProps);
    value = (0, $joUWQ$clamp)(value, minValue, maxValue);
    let { progressBarProps: progressBarProps } = (0, $joUWQ$useProgressBar)({
        ...props,
        value: value
    });
    let subMask1Style = {};
    let subMask2Style = {};
    if (!isIndeterminate) {
        let percentage = (value - minValue) / (maxValue - minValue) * 100;
        let angle;
        if (percentage > 0 && percentage <= 50) {
            angle = -180 + percentage / 50 * 180;
            subMask1Style.transform = `rotate(${angle}deg)`;
            subMask2Style.transform = "rotate(-180deg)";
        } else if (percentage > 50) {
            angle = -180 + (percentage - 50) / 50 * 180;
            subMask1Style.transform = "rotate(0deg)";
            subMask2Style.transform = `rotate(${angle}deg)`;
        }
    }
    if (!ariaLabel && !ariaLabelledby) console.warn("ProgressCircle requires an aria-label or aria-labelledby attribute for accessibility");
    return /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        ...styleProps,
        ...progressBarProps,
        ref: domRef,
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($91c958cb2e66ca21$exports))), "spectrum-CircleLoader", {
            "spectrum-CircleLoader--indeterminate": isIndeterminate,
            "spectrum-CircleLoader--small": size === "S",
            "spectrum-CircleLoader--large": size === "L",
            "spectrum-CircleLoader--overBackground": variant === "overBackground",
            "spectrum-CircleLoader--staticWhite": staticColor === "white",
            "spectrum-CircleLoader--staticBlack": staticColor === "black"
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($91c958cb2e66ca21$exports))), "spectrum-CircleLoader-track")
    }), /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($91c958cb2e66ca21$exports))), "spectrum-CircleLoader-fills")
    }, /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($91c958cb2e66ca21$exports))), "spectrum-CircleLoader-fillMask1")
    }, /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($91c958cb2e66ca21$exports))), "spectrum-CircleLoader-fillSubMask1"),
        "data-testid": "fillSubMask1",
        style: subMask1Style
    }, /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($91c958cb2e66ca21$exports))), "spectrum-CircleLoader-fill")
    }))), /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($91c958cb2e66ca21$exports))), "spectrum-CircleLoader-fillMask2")
    }, /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($91c958cb2e66ca21$exports))), "spectrum-CircleLoader-fillSubMask2"),
        "data-testid": "fillSubMask2",
        style: subMask2Style
    }, /*#__PURE__*/ (0, $joUWQ$react).createElement("div", {
        className: (0, $joUWQ$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($91c958cb2e66ca21$exports))), "spectrum-CircleLoader-fill")
    })))));
}
/**
 * ProgressCircles show the progression of a system operation such as downloading, uploading, or processing, in a visual way.
 * They can represent determinate or indeterminate progress.
 */ let $79c16f64960b6385$export$c79b9d6b4cc92af7 = /*#__PURE__*/ (0, $joUWQ$react).forwardRef($79c16f64960b6385$var$ProgressCircle);





export {$551ca31cb687f352$export$c17561cb55d4db30 as ProgressBar, $79c16f64960b6385$export$c79b9d6b4cc92af7 as ProgressCircle, $ddf9337e928b5fe6$export$7c6ed87244065f3a as ProgressBarBase};
//# sourceMappingURL=module.js.map
